document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.c-archive__menu5 > li');

  function adjustHeaderHeights() {
    // 高さをリセット
    document.querySelectorAll('.js-cardHeader').forEach(el => {
      el.style.height = '';
    });

    // 行ごとに要素をグループ化
    const rows = {};
    items.forEach(li => {
      const header = li.querySelector('.js-cardHeader');
      if (!header) return;

      const top = li.getBoundingClientRect().top;
      if (!rows[top]) rows[top] = [];
      rows[top].push(header);
    });

    // 行ごとに最大の高さを取得して揃える
    Object.values(rows).forEach(headers => {
      const maxHeight = Math.max(...headers.map(h => h.offsetHeight));
      headers.forEach(h => h.style.height = `${maxHeight}px`);
    });
  }

  // 初回実行
  adjustHeaderHeights();

  // リサイズ時に再実行（debounce付き）
  window.addEventListener('resize', () => {
    clearTimeout(window.__resizeTimer__);
    window.__resizeTimer__ = setTimeout(adjustHeaderHeights, 150);
  });
});
